'use strict';

DoohApps
    .factory('MediaAssets', ['restApi', function (restApi) {
        var controllerName = 'MediaAssets/';

        return {
            getMediaAssetsList: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetMediaList', objectFilterOptions);
            },
            updateMediaAssets: function (successCallback, media) {
                restApi.PutApiMethod(successCallback, controllerName + 'PutMedia', media);
            },
            addMediaAssets: function (successCallback, media) {
                restApi.PostApiMethod(successCallback, controllerName + 'PostMedia', media);
            },
            deleteSelectedMediaAssets: function (successCallback, mediaAssets) {
                restApi.PostApiMethod(successCallback, controllerName + 'DeleteSelectedMedia', mediaAssets);
            },
            addSelectedToArchive: function (successCallback, mediaIDs) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'AddSelectedToArchive?mediaIDs=' + mediaIDs);
            },
            addTag: function (successCallback, tag) {
                restApi.PostApiMethod(successCallback, controllerName + 'PostTag', tag);
            },
            getTagList: function (successCallback,filter) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetTagsList', filter);
            },
            checkMediaAssetsUse: function (successCallback, MediaAssets) {
                restApi.PostApiMethod(successCallback, controllerName + 'CheckMediaAssetsUse', MediaAssets);
            },
            addFolder: function (successCallback, folder) {
                restApi.PostApiMethod(successCallback, controllerName + 'PostFolder', folder);
            },
            getFolderPath: function (successCallback, folderId) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetMediaFolderPath?FolderID=' + folderId);
            },
            updateFolder: function (successCallback, folder) {
                restApi.PutApiMethod(successCallback, controllerName + 'PutFolder', folder);
            },
            checkFolderAssets: function (successCallback, folderId, count, offset) {
                restApi.GetApiMethod(successCallback, controllerName + 'CheckFolderAssets?folderID=' + folderId + '&count=' + count + '&offset=' + offset);
            },
            deleteFolder: function (successCallback, folderId) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteFolder?folderID=' + folderId);
            },
            getFolderTree: function (successCallback,company) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetMediaFolderTree?company=' + company);
            },
            changeAssetsLocation: function (successCallback, assets, newFolder) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'ChangeSelectedAssetsLocation?assets=' + assets + '&FolderID=' + newFolder);
            },
            getSnapshotFromVideo: function (successCallback, mediaFile) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetImageFromVideoBySecond', mediaFile);
            },
            addAttachedFile: function (successCallback, file) {
                restApi.PostApiMethod(successCallback, controllerName + 'AddAttachedFile', file);
            },
            deleteAttachedFile: function (successCallback, file) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteAttachedFile', file);
            },
            saveExternalCampaign: function (successCallback, assets) {
                restApi.PostApiMethod(successCallback, controllerName + 'SaveExternalCampaign', assets);
            },
            getMediaAssetsLanguageData : function(successCallback, asssetId) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetMediaAssetsLanguageData?MediaId=' + asssetId);
            },
        }
    }]).factory('MediaAssetsDataFilter', function () {
        //Filter options to Media Assets/////
        var DataFilter = {};

        DataFilter.MediaAssetsFilter = {};

        DataFilter.MediaAssetsFilter = {};
        DataFilter.MediaAssetsFilter.Offset = 0;
        DataFilter.MediaAssetsFilter.Count = '18';
        DataFilter.MediaAssetsFilter.AssetTitle = '';
        DataFilter.MediaAssetsFilter.ShowVideo = true;
        DataFilter.MediaAssetsFilter.ShowImages = true;
        DataFilter.MediaAssetsFilter.IsArchived = false;
        DataFilter.MediaAssetsFilter.FolderID = 0;
        DataFilter.MediaAssetsFilter.TotalCount = 0;
        DataFilter.MediaAssetsFilter.OrderByDate = 2;
        DataFilter.MediaAssetsFilter.OrderByTitle = 0;
        DataFilter.MediaAssetsFilter.CompanyId = 0;

        DataFilter.Clear = function () {
            DataFilter.MediaAssetsFilter.Offset = 0;
            DataFilter.MediaAssetsFilter.Count = '18';
            DataFilter.MediaAssetsFilter.AssetTitle = '';
            DataFilter.MediaAssetsFilter.ShowVideo = true;
            DataFilter.MediaAssetsFilter.ShowImages = true;
            DataFilter.MediaAssetsFilter.IsArchived = false;
            DataFilter.MediaAssetsFilter.TotalCount = 0;
            DataFilter.MediaAssetsFilter.OrderByDate = 2;
            DataFilter.MediaAssetsFilter.OrderByTitle = 0;
            DataFilter.MediaAssetsFilter.CompanyId = 0;
        }

        return DataFilter;
    });
